// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'table';

export const Component = () => (
  <path d='M21 1.5v19H1v-19h20Zm-1 13.75h-5.5v4.25H20v-4.25Zm-12.5 0H2v4.25h5.5v-4.25Zm6.25 0h-5.5v4.25h5.5v-4.25Zm6.25-5h-5.5v4.25H20v-4.25Zm-12.5 0H2v4.25h5.5v-4.25Zm6.25 0h-5.5v4.25h5.5v-4.25Zm6.25-5h-5.5V9.5H20V5.25Zm-12.5 0H2V9.5h5.5V5.25Zm6.25 0h-5.5V9.5h5.5V5.25Z' />
);

export const viewBox = '0 0 22 22';
